"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useBreakpoint = exports.DESKTOP_BREAKPOINTS = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _debounce = _interopRequireDefault(require("lodash/debounce"));

var _styledComponents = require("styled-components");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var sizeMap = function sizeMap(breakpoints) {
  return Object.entries(breakpoints).reduce(function (acc, _ref) {
    var _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
        key = _ref2[0],
        val = _ref2[1];

    return _objectSpread(_objectSpread({}, acc), {}, (0, _defineProperty2["default"])({}, key, Number(val.replace('px', ''))));
  }, {});
};

var DESKTOP_BREAKPOINTS = ['md', 'lg', 'xl'];
exports.DESKTOP_BREAKPOINTS = DESKTOP_BREAKPOINTS;

var useBreakpoint = function useBreakpoint() {
  var _useState = (0, _react.useState)(''),
      breakpoint = _useState[0],
      setBreakpoint = _useState[1];

  var _useContext = (0, _react.useContext)(_styledComponents.ThemeContext),
      breakpoints = _useContext.breakpoints;

  var handleResize = function handleResize() {
    var _window = window,
        innerWidth = _window.innerWidth;
    var largestBreakpoint = Object.entries(sizeMap(breakpoints)).reduce( // @ts-ignore
    function (largestFoundBreakpoint, _ref3) {
      var _ref4 = (0, _slicedToArray2["default"])(_ref3, 2),
          key = _ref4[0],
          width = _ref4[1];

      // @ts-ignore
      if (largestFoundBreakpoint.width <= width && width < innerWidth) {
        return {
          key: key,
          width: width
        };
      }

      return largestFoundBreakpoint;
    }, {
      key: '',
      width: 0
    } // @ts-ignore
    ).key;
    setBreakpoint(largestBreakpoint);
  };

  var debouncedHandleResize = (0, _debounce["default"])(handleResize, 200);
  (0, _react.useEffect)(function () {
    handleResize();
    window.addEventListener('resize', debouncedHandleResize);
    return function cleanup() {
      window.removeEventListener('resize', debouncedHandleResize);
    };
  }, [debouncedHandleResize]);
  return breakpoint;
};

exports.useBreakpoint = useBreakpoint;